import React from "react";

const AddUserForSupportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.829"
      height="46.948"
      viewBox="0 0 39.829 46.948"
    >
      <path
        id="db68"
        d="M197.478,190.758a3.468,3.468,0,0,1-4.311-2.4l-.906-3.248h-4.924a4.79,4.79,0,0,1-4.79-4.79v-4.862l-1.27-.422h0a3.258,3.258,0,0,1-1.95-4.417l2.692-6.045a6.043,6.043,0,0,0,.527-2.472,18.2,18.2,0,0,1,12.3-17.2q.268,1.84.479,3.756a14.509,14.509,0,0,0-9.063,13.412,9.692,9.692,0,0,1-.843,3.971l-2.52,5.648,1.538.517a2.635,2.635,0,0,1,1.811,2.505v5.638a1.092,1.092,0,0,0,1.092,1.092h7.7l1.633,5.748,16.492-4.709-2.73-9.58.733-.762h0a14.456,14.456,0,0,0-2.615-22.207q-.172-2.242-.431-4.407a18.146,18.146,0,0,1,6.428,28.339l2.218,7.779a3.473,3.473,0,0,1-2.4,4.311Zm-2.908-17.9a2.692,2.692,0,1,0,1.293,2.539,13.954,13.954,0,0,0,5.14-5.532,6.093,6.093,0,0,0,4.551-11.017,111.47,111.47,0,0,0-.958-14.48A17.866,17.866,0,0,0,202,144q-.642-.048-1.288-.048a18.6,18.6,0,0,0-2.6.182,102.478,102.478,0,0,1,1.068,14.408,6.088,6.088,0,0,0-.8,10.15,10.787,10.787,0,0,1-3.818,4.172Z"
        transform="translate(-179.047 -143.949)"
        fill={fill ? fill : "#4166f8"}
      />
    </svg>
  );
};

export default AddUserForSupportIcon;
